/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const voicePreferencesResponsePreferencesSpeechSpeedMin = 0.25;
export const voicePreferencesResponsePreferencesSpeechSpeedMax = 1.5;

export const VoicePreferencesResponse = zod.object({
  preferences: zod.object({
    speechSpeed: zod
      .number()
      .min(voicePreferencesResponsePreferencesSpeechSpeedMin)
      .max(voicePreferencesResponsePreferencesSpeechSpeedMax)
      .describe(
        'How fast the realtime voice agent speaks: a multiplier from 0.25 to 1.5, where 1.0 is normal.',
      ),
  }),
});

export type VoicePreferencesResponse = zod.input<typeof VoicePreferencesResponse>;
export type VoicePreferencesResponseOutput = zod.output<typeof VoicePreferencesResponse>;
